export var SENTRY_RELEASE = "8e89aa5105ab151107e63b90d74c42b9cbd19eff";
